// src/components/ServicesCard.jsx
import React from "react";

const ServicesCard = ({ title, description, img }) => {
  return (
    <div className="bg-gray-800 text-white rounded shadow-lg overflow-hidden hover:scale-105 transform transition">
      <img src={img} alt={title} loading="lazy" className="h-48 w-full object-cover" />
      <div className="p-4">
        <h3 className="text-xl font-bold mb-2">{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default ServicesCard;
